import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};



export default function MultipleSelectCheckmarks({dataArr,handleSelect,initValue=[]}) {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    handleSelect(value)
  };

  return (
      <FormControl sx={{ mt: 1, width: "100%",}}>
        <InputLabel id="demo-multiple-checkbox-label"
         sx={{width:"auto!important",background:"#fff", paddingRight:"5px"}}
        >Select Defendants</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={dataArr.filter(elem=>initValue.includes(elem.id))}
          onChange={handleChange}
          input={<OutlinedInput label="Defendants"/>}
          renderValue={(selected) => selected.map(item => item.name).join(', ')}
          MenuProps={MenuProps}
        >
          {dataArr.map((elem) => (
            <MenuItem key={elem.id} value={elem}>
              <Checkbox checked={initValue.includes(elem.id)} />
              <ListItemText primary={elem.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  );
}